import { render, staticRenderFns } from "./son2.vue?vue&type=template&id=5c8ff9c2&scoped=true"
import script from "./son2.vue?vue&type=script&lang=js"
export * from "./son2.vue?vue&type=script&lang=js"
import style0 from "./son2.vue?vue&type=style&index=0&id=5c8ff9c2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c8ff9c2",
  null
  
)

export default component.exports